import { render, staticRenderFns } from "./FerryList.vue?vue&type=template&id=562c4602"
import script from "../../controllers/ferry/ferry-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry/ferry-list.js?vue&type=script&lang=js&external"
import style0 from "./FerryList.vue?vue&type=style&index=0&id=562c4602&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports